/* eslint-disable no-nested-ternary */
import React from 'react';
import styled from 'styled-components';
import { _ } from '_locales';
import { zeroPad } from 'react-countdown';
import { connect } from 'react-redux';
import images from '_images';
import Levels from './Levels';
import GameStatusIndicator from './GameStatusIndicator';
import SecondsCounter from './SecondsCounter';
import OnBoarding from './OnBoarding';

const Container = styled.div`
  position: relative;
  overflow: hidden;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  min-height: calc(75vh - 40px - ${Number(window.statusBarHeight || 0)}px);
  user-select: none;
  outline: 0;
  box-shadow: ${({ isOnBoarding }) => (isOnBoarding ? 'inset 0 0 0 1000px rgba(0,0,0,.3)' : 'none')};
`;

const CountDownContainer = styled.div`
  display: flex;
  margin-left: auto;
  background-color: #5bc236;
  border-radius: 40px;
  padding: 2px 5px;
`;

const TimerImage = styled.img`
  height: ${({ windowsWidth }) => (windowsWidth >= 500 ? '25px' : '20px')};
  width: ${({ windowsWidth }) => (windowsWidth >= 500 ? '25px' : '20px')};
`;

const TopContainer = styled.div`
  padding: 0px 5px 5px 5px;
  display: flex;
  justify-content: space-between;
  border-bottom: 2px solid #E7ECEF;
  box-shadow: inset 0 0 0 1000px rgba(256,256,256,1);
`;

const Title = styled.div`
  display:flex;
  align-items: center;
  justify-content: center;
  font-size: ${({ windowsWidth }) => (windowsWidth >= 500 ? '18px' : '15px')};
  color: rgba(64, 64, 64, 1);
  font-weight: bold !important;
`;

const Arrow = styled.button`
  display: flex; 
  align-items: center;
  justify-content: center;
  padding: 0 5px 0 0;
  cursor: pointer;
  transition: all .3s;
  border-radius: 50%;
  border: none;
  line-height: normal;
  background-color: ${({ background }) => background} ;

  &:hover {
    border-radius: 50%;
    background-color: #EBEBF0;
    box-shadow: rgba(99, 99, 99, 0.3) 0 2px 6px 0px;
  }

  &:disabled {
     opacity: 0.3 !important;
     cursor: not-allowed;
     box-shadow: none;
  }
`;

const CardContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  width: ${({ windowsWidth }) => (windowsWidth < 400 ? '85%' : ((windowsWidth < 750 ? `${(windowsWidth * (-1 / 10) + 120)}%` : '35%')))};
  height: 52vh;
  margin: -50px auto;
  border-radius: 10px;  
  box-shadow:
  2px 2px 10px 2px rgba(0, 0, 0, 0.2);
`;

const MaterialImage = styled.img`
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  margin-left: 5%;
  margin-bottom: 5%;
  max-width: 100%;
  max-height: 70%;
  margin-left: auto;
  margin-right: auto;
  pointer-events: none;
  opacity: ${({ isOnBoarding }) => (isOnBoarding ? '0.4' : '1')};
`;

const MaterialName = styled.h2`
  text-align: center;
  font-size: 15px;
  margin-top: 1%;
  opacity: ${({ isOnBoarding }) => (isOnBoarding ? '0.4' : '1')};
`;

const ButtonsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  width: 50%;
  margin-left: auto;
  margin-right: auto;
`;

const ButtonImage = styled.img`
  height: 6.5vh;
  width: 6.5vh;
  border-radius: 50%;
  background-color: #efefef;
  background-size: contain;
  background-position: center;
  margin: 0 auto;
  box-sizing: content-box;
  user-drag: none;

  &.notRecycable {
    opacity: ${({ isOnBoarding }) => ((isOnBoarding === 'firstOnBoarding') ? '0.3' : '1')};
  }

  &.recycable {
    opacity: ${({ isOnBoarding }) => ((isOnBoarding === 'secondOnBoarding') ? '0.3' : '1')};
  }
`;

const Card = styled.div`
  overflow: hidden;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  width: 100%;
  height: 100%;
  padding: 3%;
  background-color: white;
  max-height: 100%;
  will-change: transform;
  border-radius: 10px;
  box-shadow: ${({ isOnBoarding }) => (isOnBoarding ? 'inset 0 0 0 1000px rgba(0,0,0,.3)' : 'none')};
`;

/**
 * This component is used for two different parts:
 *
 * The first part is to be a background of the on boarding modal
 *
 * The seond part is to be a background for time out modal
 *
 */

const StaticGameScreen = (
  {
    questionIndex,
    currentLevel,
    modalVisible,
    doneMaterials,
    passedMaterialsCount,
    isOnBoarding,
    recycleRightData,
    windowsWidth,
    setStartGame,
    setDisplayedContent
  }
) => (
  <Container isOnBoarding={isOnBoarding}>
    {isOnBoarding && (<OnBoarding isOnBoarding={isOnBoarding} />)}
    {/* <CloseButton src={images.recycleRight.close} /> */}
    {!isOnBoarding && (
      <TopContainer>
        <Title windowsWidth={windowsWidth}>
          <Arrow background="#fff">
            &#8678;
          </Arrow>
          {_('education.recycle_right')}
        </Title>
        <CountDownContainer>
          <SecondsCounter seconds={zeroPad('08')} isBeforeGame={false} windowsWidth={windowsWidth} />
          <TimerImage
            src={images.recycleRight.timer}
            windowsWidth={windowsWidth}
            alt="RecycleRIGHT Game timer"
          />
        </CountDownContainer>
      </TopContainer>
    )}

    <Levels
      levels={recycleRightData}
      currentLevelKey={`level_${currentLevel + 1}_materials`}
      modalVisible={modalVisible}
      windowsWidth={windowsWidth}
      isOnBoarding={isOnBoarding}
    />
    <CardContainer windowsWidth={windowsWidth} isOnBoarding={isOnBoarding}>
      <Card isOnBoarding={isOnBoarding}>
        <MaterialImage
          src={recycleRightData[`level_${currentLevel + 1}_materials`][questionIndex].mat_image}
          isOnBoarding={isOnBoarding}
          alt={`${recycleRightData[`level_${currentLevel + 1}_materials`][questionIndex].mat_nm || 'Material'} image`}
        />
        <MaterialName isOnBoarding={isOnBoarding}>
          {recycleRightData[`level_${currentLevel + 1}_materials`][questionIndex].mat_nm}
        </MaterialName>
        <ButtonsContainer>
          <ButtonImage
            className="notRecycable"
            src={images.recycleRight.decline}
            isOnBoarding={isOnBoarding}
            alt="Not recyclable button"
          />
          <ButtonImage
            className="recycable"
            src={images.recycleRight.recycable}
            isOnBoarding={isOnBoarding}
            alt="Recyclable button"
          />
        </ButtonsContainer>
      </Card>
    </CardContainer>
    <GameStatusIndicator
      totalMaterials={recycleRightData[`level_${currentLevel + 1}_materials`]}
      doneMaterials={doneMaterials}
      prevTotalMaterials={passedMaterialsCount}
      windowsWidth={windowsWidth}
      isOnBoarding={isOnBoarding}
    />
  </Container>
);

export default connect(
  (store) => ({
    recycleRightData: store.education.recycle_right
  })
)(StaticGameScreen);
